import { render, staticRenderFns } from "./viewBookedPickup.vue?vue&type=template&id=4f0dde32"
import script from "./viewBookedPickup.vue?vue&type=script&lang=js"
export * from "./viewBookedPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports